module.exports = __webpack_public_path__ + "img/wx.569aa6ff.png";